// https://getbootstrap.com/docs/4.6/layout/overview/

export const ScreenBreakpoints = {
  small: '576px',
  medium: '768px',
  large: '992px',
  extraLarge: '1200px',
};
